// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-bc2f0c21] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.vue-crumb[data-v-bc2f0c21] {
  background-image: none;
  display: inline-flex;
  height: var(--default-clickable-area);
  padding: 0;
}
.vue-crumb[data-v-bc2f0c21]:last-child {
  min-width: 0;
}
.vue-crumb:last-child .vue-crumb__separator[data-v-bc2f0c21] {
  display: none;
}
.vue-crumb--hidden[data-v-bc2f0c21] {
  display: none;
}
.vue-crumb__separator[data-v-bc2f0c21] {
  padding: 0;
  color: var(--color-text-maxcontrast);
}
.vue-crumb.vue-crumb--hovered[data-v-bc2f0c21] .button-vue {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}
.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue {
  color: var(--color-text-maxcontrast);
}
.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue:hover, .vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue:focus {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}
.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue__text {
  font-weight: normal;
}
.vue-crumb[data-v-bc2f0c21] .button-vue__text {
  margin: 0;
}
.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item {
  max-width: 100%;
}
.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item .button-vue {
  padding: 0 4px 0 16px;
  max-width: 100%;
}
.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item .button-vue__wrapper {
  flex-direction: row-reverse;
}
.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item.action-item--open .action-item__menutoggle {
  background-color: var(--color-background-dark);
  color: var(--color-main-text);
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcBreadcrumb-0xB19h6f.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qCAAqC;EACrC,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-bc2f0c21] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.vue-crumb[data-v-bc2f0c21] {\n  background-image: none;\n  display: inline-flex;\n  height: var(--default-clickable-area);\n  padding: 0;\n}\n.vue-crumb[data-v-bc2f0c21]:last-child {\n  min-width: 0;\n}\n.vue-crumb:last-child .vue-crumb__separator[data-v-bc2f0c21] {\n  display: none;\n}\n.vue-crumb--hidden[data-v-bc2f0c21] {\n  display: none;\n}\n.vue-crumb__separator[data-v-bc2f0c21] {\n  padding: 0;\n  color: var(--color-text-maxcontrast);\n}\n.vue-crumb.vue-crumb--hovered[data-v-bc2f0c21] .button-vue {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}\n.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue {\n  color: var(--color-text-maxcontrast);\n}\n.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue:hover, .vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue:focus {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}\n.vue-crumb[data-v-bc2f0c21]:not(:last-child)  .button-vue__text {\n  font-weight: normal;\n}\n.vue-crumb[data-v-bc2f0c21] .button-vue__text {\n  margin: 0;\n}\n.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item {\n  max-width: 100%;\n}\n.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item .button-vue {\n  padding: 0 4px 0 16px;\n  max-width: 100%;\n}\n.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item .button-vue__wrapper {\n  flex-direction: row-reverse;\n}\n.vue-crumb[data-v-bc2f0c21]:not(.dropdown) .action-item.action-item--open .action-item__menutoggle {\n  background-color: var(--color-background-dark);\n  color: var(--color-main-text);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
